export const AGENDA_SIDEPANEL_ACTIONS = {
  OPEN_SIDEPANEL: 'OPEN_SIDEPANEL',
  CLOSE_SIDEPANEL: 'CLOSE_SIDEPANEL',
};
